module.exports = __webpack_public_path__ + "img/Intro_text05_watch_v1.23b88a07.png";